import { useAuth } from "./auth/CognitoAuthContext";
import AccessDenied from "../pages/AccessDenied.jsx";
import { Navigate, Outlet } from "react-router-dom";
import Loading from "../pages/Loading.jsx";
import { checkUserPermission } from "./util";

export default function PrivateRoutes({ groups = [], pageTitle, denied = AccessDenied }) {
  const { initialised, session } = useAuth();
  const DeniedComponent = denied;

  if (initialised === false) {
    return <Loading />; // wait until we have initialised authentication services
  }

  // Determine the routing based on user's status
  if (session.authenticated === true && session.termsAccepted !== true) {
    return <Navigate to="/terms" />;
  }

  // check if user has permission
  const isAllowed = checkUserPermission(session.authenticated, groups, session.userInfo);

  return isAllowed ? <Outlet /> : <DeniedComponent title={pageTitle} groups={groups} />;
}
